import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getActivityList, getActivityDetail, createActivity, updateActivity, deleteActivity, auditActivity, updateActivityStatus } from '@/api/bairun/oilActivity'; //  此处请自行替换地址

import { getCapitalRelationList } from '@/api/bairun/ticket'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { getBairunPayChannelList } from '@/api/bairun/bairunPayChannel';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'PointRuleConfig',
  components: {},
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getActivityList,
      type: '',
      path: process.env.VUE_APP_BASE_API,
      discountLevel: 1,
      activityType: 100004,
      fullscreenLoading: false,
      multipleSelection: [],
      addDialogVisible: false,
      viewDialogVisible: false,
      auditDialogVisible: false,
      dialogTitle: '',
      dateRangeValueArr: [],
      stationOptions: [],
      stationIdChecked: [],
      stationCheckAll: false,
      oilCodesOptions: [],
      oilCodesCheckAll: false,
      oilCodesChecked: [],
      sellerOrderTypeOptions: [{
        'value': 1,
        'label': '加油订单'
      }, {
        'value': 2,
        'label': '便利店订单'
      }],
      payChannelOptions: [],
      payChannelCheckAll: false,
      payChannelChecked: [],
      capitalOptions: [],
      formData: {},
      publicRules: {
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        dateRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (_this.dateRangeValueArr.length !== 2) {
              callback(new Error('请选择时间范围'));
            } else {
              callback();
            }
          }
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo', 'token'])), {}, {
    // eslint-disable-next-line vue/return-in-computed-property
    getRule: function getRule() {
      return this.publicRules;
    }
  }),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.getDict('oilCode').then(function (res) {
                  _this3.oilCodesOptions = res;
                });

                getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                }).then(function (res) {
                  _this3.stationOptions = res.data.list;
                });
                getBairunPayChannelList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                }).then(function (res) {
                  _this3.payChannelOptions = res.data.list.filter(function (item) {
                    return item.payChannel >= 1000 && item.payChannel < 2000 && [0, 1].includes(item.supportType);
                  });
                });
                getCapitalRelationList({
                  'page': 1,
                  'pageSize': 999
                }).then(function (res) {
                  if (res.code == 0) {
                    _this3.capitalOptions = res.data.list;
                  }
                });
                _this3.formData = _this3.initData();

                _this3.onSubmit();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        activityNo: '',
        activityPointNo: '',
        activityName: '',
        activityStatus: 2,
        dateStart: '',
        dateEnd: '',
        auditStatus: 2,
        auditRemark: '',
        isRepeat: 1,
        perdayLimit: 999999,
        sellerOrderType: 1,
        limitType: 1,
        limitNum: 0,
        everyNum: '',
        point: '',
        capitalId: 0
      };
      return formdata;
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.discountLevel = this.discountLevel;
      this.searchInfo.activityType = this.activityType;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.searchInfo.discountLevel = this.discountLevel;
      this.searchInfo.activityType = this.activityType;
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 新增
    onAdd: function onAdd() {
      this.type = 'add';
      this.addDialogVisible = true;
      this.dialogTitle = '新增积分规则';
      this.formData.capitalId = this.capitalOptions[0].capitalId;
      this.handleStationCheckAllChange(true);
      this.handleOilCheckAllChange(true);
      this.handlePayChannelCheckAllChange(true);
    },
    // 查看
    onRowdbclick: function onRowdbclick(row) {
      var that = this;
      that.onView(row);
    },
    onView: function onView(row) {
      this.type = 'view';
      this.dialogTitle = '查看积分规则';
      this.viewDialogVisible = true;
      this.handleViewOrUpdate(row);
    },
    // 修改
    onUpdate: function onUpdate(row) {
      var that = this;
      that.type = 'update';
      that.addDialogVisible = true;
      that.dialogTitle = '变更积分规则';
      that.handleViewOrUpdate(row);
    },
    handleViewOrUpdate: function handleViewOrUpdate(row) {
      var that = this;
      getActivityDetail({
        'activityNo': row.activityNo
      }).then(function (res) {
        that.formData.activityNo = res.data.activityMain.activityNo;
        that.formData.activityPointNo = res.data.activitySubPoint.activityPointNo;
        that.formData.activityName = res.data.activityMain.activityName;
        that.formData.activityStatus = res.data.activityMain.activityStatus;
        that.formData.dateStart = that.$options.filters.formatDate(res.data.activityMain.dateStart);
        that.formData.dateEnd = that.$options.filters.formatDate(res.data.activityMain.dateEnd);
        that.formData.auditStatus = res.data.activityMain.auditStatus;
        that.formData.auditRemark = res.data.activityMain.auditRemark;
        res.data.activityMain.activityMainSellerList.forEach(function (item) {
          that.stationIdChecked.push(item.sellerId);
        });
        that.stationCheckAll = that.stationIdChecked.length == that.stationOptions.length;
        res.data.activityMain.activityGoodsList.forEach(function (item) {
          that.oilCodesChecked.push(parseInt(item.goodsSpu));
        });
        that.oilCodesCheckAll = that.oilCodesChecked.length == that.oilCodesOptions.length;
        res.data.activityMain.activityPayChannelList.forEach(function (item) {
          that.payChannelChecked.push(parseInt(item.payChannel));
        });
        that.payChannelCheckAll = that.payChannelChecked.length == that.payChannelOptions.length; // 不能用以下写法，回显会不展示
        // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.dateStart)
        // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.dateEnd)

        that.dateRangeValueArr = [that.formData.dateStart, that.formData.dateEnd];
        that.formData.activityPointNo = res.data.activitySubPoint.activityPointNo;
        that.formData.sellerOrderType = res.data.activitySubPoint.sellerOrderType;
        that.formData.limitType = res.data.activitySubPoint.limitType;
        that.formData.limitNum = res.data.activitySubPoint.limitNum;
        that.formData.everyNum = res.data.activitySubPoint.everyNum;
        that.formData.point = res.data.activitySubPoint.point;
        that.formData.capitalId = res.data.activitySubPoint.capitalId;
        that.$forceUpdate();
      }, function (error) {});
    },
    // 审核
    onAudit: function onAudit(row) {
      this.type = 'audit';
      this.auditDialogVisible = true;
      this.dialogTitle = '审核操作';
      this.formData.activityNo = row.activityNo;
    },
    handleAudit: function handleAudit() {
      var that = this;
      auditActivity({
        'activityNo': this.formData.activityNo,
        'auditStatus': this.formData.auditStatus,
        'auditRemark': this.formData.auditRemark
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 启用
    onAble: function onAble(row) {
      var that = this;
      updateActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 1
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 禁用
    onDisable: function onDisable(row) {
      var that = this;
      updateActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 2
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteActivity({
          'activityNo': row.activityNo
        }).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.enterDialogRepose(res);
          }
        }, function (error) {});
      }).catch(function (err) {});
    },
    // 可积分订单勾选
    onChangeSellerOrderType: function onChangeSellerOrderType() {
      if (this.formData.sellerOrderType == 2 && this.formData.limitType == 2) {
        this.formData.limitType = 1;
        this.formData.limitNum = '';
        this.formData.everyNum = '';
        this.formData.point = '';
      }
    },
    // 油品全选
    handleOilCheckAllChange: function handleOilCheckAllChange(val) {
      this.oilCodesChecked = val ? this.oilCodesOptions.map(function (oil) {
        return oil.value;
      }) : [];
      this.oilCodesCheckAll = this.oilCodesChecked.length === this.oilCodesOptions.length;
    },
    // 油品勾选
    handleCheckedOilCodesChange: function handleCheckedOilCodesChange(value) {
      this.oilCodesCheckAll = value.length === this.oilCodesOptions.length;

      if (this.oilCodesCheckAll) {
        this.handleOilCheckAllChange(true);
      }
    },
    // 油站全选
    handleStationCheckAllChange: function handleStationCheckAllChange(val) {
      this.stationIdChecked = val ? this.stationOptions.map(function (item) {
        return item.ID;
      }) : [];
      this.stationCheckAll = this.stationIdChecked.length === this.stationOptions.length;
    },
    // 油站勾选
    handleCheckedStationChange: function handleCheckedStationChange(value) {
      this.stationCheckAll = value.length === this.stationOptions.length;

      if (this.stationCheckAll) {
        this.handleStationCheckAllChange(true);
      }
    },
    // 支付方式全选
    handlePayChannelCheckAllChange: function handlePayChannelCheckAllChange(val) {
      this.payChannelChecked = val ? this.payChannelOptions.map(function (item) {
        return item.payChannel;
      }) : [];
      this.payChannelCheckAll = this.payChannelChecked.length === this.payChannelOptions.length;
    },
    // 支付方式勾选
    handleCheckedPayChannelChange: function handleCheckedPayChannelChange(value) {
      this.payChannelCheckAll = value.length === this.payChannelOptions.length;

      if (this.payChannelCheckAll) {
        this.handlePayChannelCheckAllChange(true);
      }
    },
    closeDialog: function closeDialog() {
      this.addDialogVisible = false;
      this.viewDialogVisible = false;
      this.auditDialogVisible = false;
      this.type = '';
      this.dialogTitle = '';
      this.dateRangeValueArr = [];
      this.stationIdChecked = [];
      this.stationCheckAll = false;
      this.oilCodesCheckAll = false;
      this.oilCodesChecked = [];
      this.payChannelCheckAll = false;
      this.payChannelChecked = [];
      this.formData = this.initData();
    },
    onDialogSubmit: function onDialogSubmit() {
      var that = this;

      switch (that.type) {
        case 'add':
          that.handleAdd();
          break;

        case 'update':
          that.handleUpdate();
          break;

        case 'audit':
          that.handleAudit();
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handleAdd: function handleAdd() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                that.$refs['formData'].validate(function (valid) {
                  if (valid && that.validFormData()) {
                    createActivity(that.getParam()).then(function (res) {
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 变更保存
    handleUpdate: function handleUpdate() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                console.log(that.formdata);
                that.$refs['formData'].validate(function (valid) {
                  if (valid && that.validFormData()) {
                    var param = that.getParam();
                    param.auditStatus = 1;
                    param.activityStatus = 2;
                    updateActivity(param).then(function (res) {
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 公共校验函数
    validFormData: function validFormData() {
      var that = this;

      if (that.stationIdChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择活动油站'
        });
        return false;
      }

      if (this.formData.sellerOrderType == 1 && that.oilCodesChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择活动油品'
        });
        return false;
      }

      if (that.payChannelChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择支付方式'
        });
        return false;
      }

      if (that.formData.capitalId == 0) {
        that.$message({
          type: 'warning',
          message: '请选择出资方'
        });
        return false;
      }

      if (that.formData.point <= 0) {
        that.$message({
          type: 'warning',
          message: '请输入赠送积分'
        });
        return false;
      }

      return true;
    },
    getParam: function getParam() {
      var that = this;
      var formData = JSON.parse(JSON.stringify(that.formData));
      var param = {
        activityNo: formData.activityNo,
        activityName: formData.activityName,
        activitySellerType: this.discountLevel,
        activityType: this.activityType,
        activityStatus: formData.activityStatus,
        dateStart: this.dateRangeValueArr[0],
        dateEnd: this.dateRangeValueArr[1],
        activityMainRule: {
          isNewRegister: 2,
          isNewPay: 2,
          isNeedShare: 2,
          isLimitGoods: 1,
          isLimitSeller: 1,
          isLimitPayChannel: 1,
          isShowDialog: 2,
          isRepeat: this.formData.isRepeat,
          perdayLimit: this.formData.perdayLimit,
          isLimitUserGroup: 2,
          isLimitSvcGroup: 2
        },
        activityGoodsList: [],
        activityMainSellerList: [],
        activityPayChannelList: [],
        activitySvcGroupList: [],
        activityUserGroupList: [],
        activitySubPoint: {
          activityPointNo: formData.activityPointNo,
          sellerOrderType: formData.sellerOrderType,
          limitType: formData.limitType,
          limitNum: formData.limitNum,
          everyNum: formData.everyNum,
          point: formData.point,
          capitalId: formData.capitalId
        }
      };
      that.oilCodesChecked.forEach(function (item) {
        param.activityGoodsList.push({
          'goodsSpu': item + '',
          'sellerGoodsType': 1
        });
      });
      that.stationIdChecked.forEach(function (item) {
        param.activityMainSellerList.push({
          'sellerId': parseInt(item)
        });
      });
      that.payChannelChecked.forEach(function (item) {
        param.activityPayChannelList.push({
          'payChannel': parseInt(item)
        });
      });
      return param;
    }
  }
};